/* React */
import React from 'react';

/* Translations */
import { useTranslation } from 'react-i18next';

/* Styled Components */
import {
  Container,
  BtnWrapper,
  Header,
  Warning,
  List,
  Cancel,
  Delete,
  Message,
} from './styles';

interface DeleteClassroomViewProps {
  classroomName: string;
  onCancel: any;
  onDelete: any;
  studentsLength?: any;
}

const DeleteClassroomView: React.FC<DeleteClassroomViewProps> = ({
  onCancel,
  onDelete,
  classroomName,
  studentsLength,
}) => {
  const { t: translate } = useTranslation();

  return (
    <Container>
      <div>
        <Header>
          {translate('settings:DELETE_MODAL.DELETE_TITLE_CLASSROOM')}
          <span id="deleteClassroomName">
            {' '}
            { classroomName }
          </span>
?
        </Header>
        <br />
        <Warning>
          {translate(
            'settings:DELETE_MODAL.DELETE_SUBTITLE',
          )}
        </Warning>
        <List>
          <li>
            {`${studentsLength} ${translate(
              'settings:DELETE_MODAL.STUDENT',
            )}`}
          </li>
        </List>
        <br />
        <Message>{translate('settings:DELETE_MODAL.DELETE_TEXT_CLASSROOM')}</Message>
      </div>
      <BtnWrapper>
        <Cancel rounded outline color="#8295A3" onClick={onCancel}>
          {translate('CANCEL')}
        </Cancel>
        <Delete
          rounded
          outline
          color="#EF4B48"
          onClick={() => onDelete('--id--')}
        >
          {translate('settings:DELETE')}
        </Delete>
      </BtnWrapper>
    </Container>
  );
};

export default DeleteClassroomView;
